// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@eisinc/Overrides/Pages/Header";
import { color, layoutContainer, xScreen } from "@eisinc/XDL/Utilities";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

headerStyles.page = {
    css: css`
        position: relative;
        z-index: ${getProp("theme.zIndex.header")};
        ${xScreen("lte", "md")} {
            position: fixed;
            background-color: ${color("common.white")};
            top: 0;
            width: 100%;
        }
    `,
};

headerStyles.navigationContainer = {
    css: css`
        transition: top 350ms ease-in;
        background-color: ${color("common.ui5")};

        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

headerStyles.innerNavigationContainer = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-start;
        ${layoutContainer}
    `,
};
